import { Component, Host, h, Prop, State, Element, Listen, EventEmitter, Event } from '@stencil/core';

@Component({
  tag: 'dda-header-menu',
  styleUrls: ['dda-header-menu.css'],
  shadow: false,
})
export class DdaHeaderMenu {
  @Element() el: HTMLElement;
  
  @Event() navigatorClick?: EventEmitter<string>;
  @Prop() showQuickLinksIcon: boolean;
  @Prop() useNavigator: 'true' | 'false' = 'false';
@Prop() quickLinks: string | Array<{
    headerMenuLabel: string;
    headerMenuId: string;
    description: string;
    url: string;
    quickLinksIcon: string;
    type?: 'dda_default_submenu' | 'dda_main_megamenu';
    children?: any;
}> = [];  @State() openIndex: number | null = null;
  @State() openSubIndex: number | null = null;

  get parsedMenuItems() {
    if (typeof this.quickLinks === 'string') {
      try {
        return JSON.parse(this.quickLinks);
      } catch {
        console.warn('Invalid JSON in quickLinks');
        return [];
      }
    }
    return this.quickLinks;
  }

  handleToggle(index: number, hasSubmenu: boolean, event: Event, item: any) {
    if (hasSubmenu) {
      event.preventDefault();
      this.openIndex = this.openIndex === index ? null : index;
      this.openSubIndex = null;
    }else{
      if(this.useNavigator == "true"){

        this.navigatorClick.emit(item.url)
      }
    }
  }

  handleClickOutside = (event: MouseEvent) => {
    const target = event.target as HTMLElement;
    if (!this.el.contains(target)) {
      this.openIndex = null;
      this.openSubIndex = null;
    }
  };

  connectedCallback() {
    document.addEventListener('click', this.handleClickOutside);
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.handleClickOutside);
  }

  @Listen('keydown', { target: 'window' })
  handleKeydown(event: KeyboardEvent) {
    if (event.key === 'Escape') {
      this.openIndex = null;
      this.openSubIndex = null;
    }
  }

  renderDefaultSubmenu(children, isOpen, submenuId, headerMenuLabel) {
    return (
      <div
        class={{
          'dda-default-submenu': true,
          'is-visible': isOpen,
        }}
        id={submenuId}
        aria-label={`${headerMenuLabel} Submenu`}
      >
        <ul>
          {children.map((item, subIndex) => {
            const hasSubSubmenu = item.children && item.children.length > 0;
            const subSubmenuId = `subsubmenu-${submenuId}-${subIndex}`;
            const isSubOpen = this.openSubIndex === subIndex;

            return (
              <li>
                

                <a
                  href={this.useNavigator == "true" ? 'javascript:void(0)' : item.url}
                  id={item.headerMenuId}
                  aria-haspopup={hasSubSubmenu ? 'true' : undefined}
                  aria-expanded={hasSubSubmenu ? String(isSubOpen) : undefined}
                  aria-controls={hasSubSubmenu ? subSubmenuId : undefined}
                  class={{
                    'has-submenu': hasSubSubmenu,
                    'active': isSubOpen,
                  }}
                  onClick={e => {
                    if (hasSubSubmenu) {
                      e.preventDefault();
                      this.openSubIndex = this.openSubIndex === subIndex ? null : subIndex;
                    }else{
                      if(this.useNavigator == "true"){

                        this.navigatorClick.emit(item.url)
                      }
                    }
                  }}
                >
                  {item.headerMenuLabel}
                </a>

                {hasSubSubmenu && (
                  <div
                    class={{
                      'dda-default-subsubmenu': true,
                      'is-visible': isSubOpen,
                    }}
                    id={subSubmenuId}
                    aria-label={`${item.headerMenuLabel} Sub Submenu`}
                  >
                    <div class="dda-default-subsubmenu-content">
                      <span class="dda-submenu-title">{item.defaultSubMenuTitle || item.headerMenuLabel}</span>
                      <ul>
                        {item.children.map((subItem, subItemIndex) => (
                          <li>
                            <a
                              // href={subItem.url}
                              href={this.useNavigator == "true" ? 'javascript:void(0)' : subItem.url}
                              id={`${subSubmenuId}-${subItemIndex}`}
                              onClick={() => this.useNavigator == "true" ? this.navigatorClick.emit(subItem.url) : ""}
                            >
                              {subItem.headerMenuLabel}
                            </a>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                )}
              </li>
            );
          })}
        </ul>
      </div>
    );
  }

  renderMegaMenu(children, isOpen, submenuId, headerMenuLabel) {
    return (
      <div
        class={{
          'dda-main-megamenu': true,
          'is-visible': isOpen,
        }}
        id={submenuId}
        aria-label={`${headerMenuLabel} Mega Menu`}
      >
        <div class="dda-megamenu-wrap">
          <div class="dda-megamenu-content">
            <div class="dda-row">
              {children.map((col, colIndex) => (
                <div class="dda-col-md-3" key={`col-${colIndex}`}>
                  {col.title && <h6 aria-label={`${col.title} section`} class="megamemu-sub-title">{col.title}</h6>}
                  <ul>
                    {col.items.map((item, itemIndex) => (
                      <li key={`item-${itemIndex}`}>
                        
                        <a
                          class="dda-mega-menu-link"
                          // href={item.url}
                          href={this.useNavigator == "true" ? 'javascript:void(0)' : item.url}
                          onClick={() => this.useNavigator == "true"?  this.navigatorClick.emit(item.url) :""}
                        >
                          {this.showQuickLinksIcon ? (
                            <span class="dda-mega-menu-icon" aria-hidden="true">
                              <i class="material-icons material-symbols-outlined">
                                {item.quickLinksIcon ? item.quickLinksIcon : "sentiment_satisfied"}
                              </i>
                            </span>
                          ) : ""}
                          <span class="text-wrap">
                            <span class="dda-mega-menu-text">{item.headerMenuLabel}</span>
                            {item.description && (
                              <span class="dda-mega-menu-desc">
                                {item.description}
                              </span>
                            )}
                          </span>
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    return (
      <Host>
        <nav aria-label="Main navigation" class="dda-header-menu">
          <ul class="dda-mega-menu">
            {this.parsedMenuItems.map((item, index) => {
              const isOpen = this.openIndex === index;
              const hasSubmenu = item.children && item.children.length > 0;
              const submenuId = `submenu-${index}`;
              const type = item.type;

              return (
                <li key={`top-${index}`}>
                  
                  <a
                    // href={item.url}
                    href={this.useNavigator == "true" ? 'javascript:void(0)' : item.url}
                    aria-haspopup={hasSubmenu ? 'true' : undefined}
                    aria-expanded={hasSubmenu ? String(isOpen) : undefined}
                    aria-controls={hasSubmenu ? submenuId : undefined}
                    
                    class={isOpen ? 'active' : ''}
                    onClick={e => this.handleToggle(index, hasSubmenu, e, item)}
                  >
                    {item.headerMenuLabel}
                  </a>

                  {hasSubmenu && type === 'dda_default_submenu' &&
                    this.renderDefaultSubmenu(item.children, isOpen, submenuId, item.headerMenuLabel)}

                  {hasSubmenu && type === 'dda_main_megamenu' &&
                    this.renderMegaMenu(item.children, isOpen, submenuId, item.headerMenuLabel)}
                </li>
              );
            })}
          </ul>
        </nav>
      </Host>
    );
  }
}
